<template>
	<div class="productstation">
		<HNB></HNB>
			<div class="imgbox">
				<div v-if="activename === i.product" class="imgCell" v-for="(i,index) in newList" :key = 'index'>
					 <div v-html="i.product_html"></div> 
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import request from '../common/request.js'
	// import axios from 'axios'
	import global from '../common/global.js'
	export default {
		name: 'Productstation',
		mounted() {
			this.listDate();
			this.activename = this.$route.query.cpzname||'desk'
			
			console.log("globalname",this.activename)
			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}

		},
		onload(option){
			       this.$route.query.setid
			        console.log(option.globalname); //打印出上个页面传递的参数。
		},
		methods: {
			async listDate() {
				// 获取点击的产品信息
				let res = await this.$Cloud.table(`lf_func_lefan_product`).get({
					page: 0,
					pageSize: 1000
				})
				
				
				const {
					code,
					data
				} = res
				if (code == 200) {
					this.newList = data.filter(item => item.product == this.activename )
					console.log('获取商品列表====>>>>>>', this.newList)
					// this.listData = data.filter(item => item.is_check == 2)
				}
				
				// request.uniRequest('/product/getProductList').then(res => {
				// 	this.newList = res.data.filter(item => item.active_name == this.activename )
				// }).catch(e => {})

			}},
		data() {
			return {
				activename: '',
				newList:[],
				listdata: [
				]

			}
		},
		components: {
			HNB
		},
	}
</script>

<style>
	*{
		padding: 0;
		margin: 0;
	}
	.productstation {
		max-width: 33.75rem;
		margin: 0 auto;
		
	}

	.productstation .imgbox {
		width: 100%;
		margin: 0 a;
		display: flex;
		flex-direction: column;
		/* border: yellow solid; */
	}
	
	.productstation .imgbox .imgCell{

	}

	.productstation .imgbox img {
		width: 100%;
		height: 100%;
		display: block;
		/* border: #006600 solid; */
	}
	
	
</style>
